import { useCallback, useContext } from 'react';
import { isNumber } from 'ggApp/types/common';
import { ReactRouterContext } from '../components';
import { NavigateFunction } from '../types';

function useNavigate(): NavigateFunction {
    const { router } = useContext(ReactRouterContext);

    const navigate = useCallback<NavigateFunction>(
        (to, options) => {
            if (isNumber(to)) {
                router.go(to);
                return;
            }

            options?.replace ? router.replace(to) : router.push(to);
        },
        [router],
    );

    return navigate;
}

export default useNavigate;
